import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import { getGuideYear } from '@/lib/filters/date/date-utils'
import { topRatedScoreForCurrentYearQueryOptions } from "@/lib/hooks/top-rated-score";
import { isCurrentPage } from '@/lib/utils'
import FirmOrNetworkTopRatedStatus from '@/modules/top-rated/status'
import { DataLoader } from '@/types/router-context'
import { TOP_RATED_STATUS_PATH, TOP_RATED_STATUS_URL } from '@/utils/urls'

export const Route = createFileRoute(TOP_RATED_STATUS_PATH)({
  component: RouteComponent,
  loader: ({ context: { queryClient } }: DataLoader) => {
    if (isCurrentPage(TOP_RATED_STATUS_URL)) {
      return
    }

    queryClient.prefetchQuery(topRatedScoreForCurrentYearQueryOptions())
  },
  beforeLoad: () => {
    const guideYear = getGuideYear()

    return {
      breadcrumbs: [
        {label: 'Top Rated Tracker', path: '#'},
        {label: `Top Rated Status ${guideYear}`, path: TOP_RATED_STATUS_URL},
      ],
      children: <div className={'h-10'}></div>
    }
  }
})

function RouteComponent() {
  return (
    <Authorisation roles={[]} permissions={[]} forbiddenFallback={<Unauthorized/>}>
      <FirmOrNetworkTopRatedStatus />
    </Authorisation>
  )
}
